import styled from 'styled-components';

import colors from '~/styles/colors';

export const Container = styled.footer`
  color: ${colors.grey3};
  padding: 32px 0;
  text-align: center;

  a {
    color: ${colors.grey3};
    text-decoration: none;
    transition: color 300ms ease;

    &:hover {
      color: ${colors.grey2};
    }
  }
`;
